if (!customElements.get('tk-product-promo-content')) {
  customElements.define('tk-product-promo-content', class extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.scheduleFit = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fitText());
      };
      this.resizeObserver = new ResizeObserver(this.scheduleFit);
      this.resizeObserver.observe(this.parentElement);
      this.mobile.addEventListener('change', this.scheduleFit);
      this.scheduleFit();
      document.fonts.ready.then(() => {
        if (this.isConnected) this.scheduleFit();
      });
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.mobile.removeEventListener('change', this.scheduleFit);
      cancelAnimationFrame(this.frame);
    }

    fitText() {
      const lines = [...this.children];
      lines.forEach(line => line.style.removeProperty('font-size'));
      if (!this.mobile.matches || !this.clientWidth) return;

      lines.forEach(line => {
        const width = line.getBoundingClientRect().width;
        if (width > 0 && line.scrollWidth > width) {
          const size = parseFloat(getComputedStyle(line).fontSize);
          line.style.fontSize = `${Math.floor(size * width / line.scrollWidth * 100) / 100}px`;
        }
      });
    }
  });
}
